<template>
    <div>
        <RedemptionEmailImportBanner :redemption-type="redemptionType" />

        <div class="flex justify-between">
            <h4 class="text-slate-800 dark:text-slate-100 text-base font-medium mb-8">
                {{ redemptionType?.name === 'Other' ? 'Redemption' : redemptionType?.name }}
            </h4>
            <div
                v-if="
                    !showEmailImportBanner &&
                    isSubscribed &&
                    (redemptionType?.slug === 'hotel' ||
                        redemptionType?.slug === 'flight')
                "
                class="flex items-center gap-2 mb-6"
            >
                <Icon icon="email-forward" :width="16" :height="16" />
                <button
                    type="button"
                    @click="showLearnMoreModal = true"
                    class="text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-slate-800 dark:hover:text-slate-100"
                >
                    Import redemptions from email
                </button>
            </div>
        </div>

        <HotelForm
            v-if="redemptionType?.slug === 'hotel'"
            :dateStartConfig="dateStartConfig"
        />

        <FlightTrainForm
            v-if="redemptionType?.slug === 'flight'"
            type="flight"
            :dateStartConfig="dateStartConfig"
            :dateEndConfig="dateEndConfig"
            v-model:differentArrivalDate="differentArrivalDate"
            :onStartChange="onStartChange"
            :onEndChange="onEndChange"
            :onDepartureDateOpen="onDepartureDateOpen"
            :segments="segments"
            :handleSegmentsUpdated="handleSegmentsUpdated"
        />

        <FlightTrainForm
            v-if="redemptionType?.slug === 'train'"
            type="train"
            :dateStartConfig="dateStartConfig"
            :dateEndConfig="dateEndConfig"
            v-model:differentArrivalDate="differentArrivalDate"
            :onStartChange="onStartChange"
            :onEndChange="onEndChange"
            :onDepartureDateOpen="onDepartureDateOpen"
            :segments="segments"
            :handleSegmentsUpdated="handleSegmentsUpdated"
        />

        <RentalCarForm
            v-if="redemptionType?.slug === 'rental-car'"
            :dateStartConfig="dateStartConfig"
        />

        <OtherForm
            v-if="redemptionType?.slug === 'other'"
            :dateStartConfig="dateStartConfig"
        />

        <div class="mb-8">
            <Textarea
                label="Notes"
                placeholder="Any notes and details on this redemption"
                id="notes"
                v-model:inputValue="activeRedemption.notes"
            />
        </div>

        <RedemptionFileUpload />
    </div>
</template>

<script setup>
import Textarea from '@/components/ui/inputs/ui-textarea.vue';
import HotelForm from './redemption-step-2/HotelForm.vue';
import FlightTrainForm from './redemption-step-2/FlightTrainForm.vue';
import RentalCarForm from './redemption-step-2/RentalCarForm.vue';
import OtherForm from './redemption-step-2/OtherForm.vue';
import RedemptionFileUpload from './redemption-step-2/RedemptionFileUpload.vue';
import RedemptionEmailImportBanner from './redemption-step-2/RedemptionEmailImportBanner.vue';
import Icon from '@/components/ui/icon/icon.vue';
import { useRedemptionForm } from '@/composables/useRedemptionForm';
import { useEmailImport } from '@/composables/useEmailImport';

const {
    activeRedemption,
    redemptionType,
    segments,
    dateStartConfig,
    dateEndConfig,
    differentArrivalDate,
    onStartChange,
    onEndChange,
    onDepartureDateOpen,
    handleSegmentsUpdated,
} = useRedemptionForm();

const {
    isSubscribed,
    showLearnMoreModal,
    showEmailImportBanner,
} = useEmailImport();
</script>
